import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'react-bootstrap';

import * as questionsActions from '../../actions/questionsActionCreators';
import * as paymentActions from '../../actions/paymentActionCreators';
import { productsList } from '../../constant';
import './style.css';

class ProductContainer extends React.Component {

  onAddToCart(productId) {
    const { history, actions } = this.props;
    actions.paymentActions.addToCart(productId);

    history.push('/questionnaire/' + history.location.search );
  }

  render() {
    return (
      <div className="container page-space-top page-space-bottom">
        <h2 className="page-header">Letters</h2>
        <hr className="header-underline"/>

        <div className="row mx-gutters-2 justify-content-center">
        {
          productsList.filter(el => el.id == 0 || el.id == 3 || el.id == 4).map((product, index) => (
            <div className="col-md-6 col-lg-5 pb-3" key={index}>
              <div className="card-bordered product-card">
                <div className="product-card-img">
                  <img src={product.data.image} className="img-fluid w-100" />
                </div>
                <div className="product-card-item d-flex flex-column justify-content-center text-center">
                  <div className="d-flex justify-content-center mb-3">
                    {(product.ref === 'travel-letter' || product.ref === 'combo-letter' || product.ref === 'psd-letter' || product.ref === 'psd-letter-combo') &&
                    <div className="align-items-center d-flex mx-3">
                      <span className="mr-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M22.0008 5.08423C22.0016 4.47445 21.8214 3.87814 21.4831 3.37086C21.1447 2.86358 20.6634 2.46816 20.1 2.23469C19.5367 2.00122 18.9168 1.94022 18.3188 2.05941C17.7207 2.17861 17.1716 2.47263 16.7408 2.90423L13.9308 5.71423L7.44079 3.55423C7.268 3.49992 7.0837 3.49356 6.90758 3.53583C6.73145 3.5781 6.57012 3.66741 6.44079 3.79423L4.06079 6.15423C3.94802 6.26831 3.86435 6.40784 3.81684 6.56105C3.76932 6.71426 3.75937 6.87665 3.7878 7.03452C3.81624 7.19239 3.88223 7.3411 3.98022 7.4681C4.07821 7.5951 4.20531 7.69667 4.35079 7.76423L9.53079 10.1142L6.93079 12.7142L5.22079 11.8542C5.03617 11.7543 4.82477 11.715 4.61658 11.7419C4.40838 11.7689 4.21393 11.8606 4.06079 12.0042L2.29079 13.8142C2.10454 14.0016 2 14.255 2 14.5192C2 14.7834 2.10454 15.0369 2.29079 15.2242L8.78079 21.7142C8.96815 21.9005 9.22161 22.005 9.48579 22.005C9.74998 22.005 10.0034 21.9005 10.1908 21.7142L12.0008 19.9442C12.1509 19.7957 12.2501 19.6035 12.2842 19.3951C12.3184 19.1867 12.2856 18.9729 12.1908 18.7842L11.3308 17.0742L13.9308 14.4742L16.2808 19.6542C16.3484 19.7997 16.4499 19.9268 16.5769 20.0248C16.7039 20.1228 16.8526 20.1888 17.0105 20.2172C17.1684 20.2457 17.3308 20.2357 17.484 20.1882C17.6372 20.1407 17.7767 20.057 17.8908 19.9442L20.2508 17.5842C20.3776 17.4549 20.4669 17.2936 20.5092 17.1174C20.5515 16.9413 20.5451 16.757 20.4908 16.5842L18.3308 10.0942L21.1008 7.26423C21.388 6.97879 21.6155 6.63903 21.77 6.26474C21.9246 5.89046 22.003 5.48915 22.0008 5.08423ZM19.6808 5.85423L16.4408 9.09423C16.314 9.22355 16.2247 9.38489 16.1824 9.56101C16.1401 9.73714 16.1465 9.92144 16.2008 10.0942L18.3608 16.5742L17.4608 17.4742L15.1108 12.3042C15.0441 12.1574 14.9429 12.0289 14.8158 11.9296C14.6886 11.8304 14.5394 11.7633 14.3808 11.7342C14.2209 11.705 14.0562 11.7153 13.9011 11.7641C13.7461 11.8129 13.6052 11.8987 13.4908 12.0142L9.37079 16.1742C9.22288 16.322 9.125 16.5124 9.09092 16.7187C9.05684 16.925 9.08827 17.1367 9.18079 17.3242L10.0008 19.0042L9.44079 19.5642L4.41079 14.5242L5.00079 14.0042L6.71079 14.8642C6.89828 14.9568 7.11006 14.9882 7.31634 14.9541C7.52262 14.92 7.71303 14.8221 7.86079 14.6742L12.0008 10.5142C12.1157 10.4002 12.2012 10.26 12.25 10.1057C12.2988 9.95135 12.3093 9.78748 12.2808 9.62814C12.2523 9.46881 12.1855 9.31879 12.0862 9.19095C11.9869 9.06312 11.8581 8.96129 11.7108 8.89423L6.50079 6.54423L7.40079 5.64423L13.8808 7.80423C14.0536 7.85854 14.2379 7.8649 14.414 7.82263C14.5901 7.78036 14.7515 7.69105 14.8808 7.56423L18.1208 4.32423C18.2204 4.22233 18.3394 4.14137 18.4708 4.08609C18.6022 4.03082 18.7433 4.00234 18.8858 4.00234C19.0283 4.00234 19.1694 4.03082 19.3008 4.08609C19.4321 4.14137 19.5511 4.22233 19.6508 4.32423C19.7551 4.42087 19.8376 4.53865 19.8928 4.66971C19.948 4.80076 19.9746 4.94208 19.9708 5.08423C19.9762 5.22543 19.9534 5.36628 19.9036 5.49851C19.8538 5.63075 19.778 5.75169 19.6808 5.85423Z"
                            fill="#7EC7D1"/>
                        </svg>
                      </span>
                      <span className="text-blured"><b>Travel</b></span>
                    </div>
                    }

                    {(product.ref === 'housing-letter' || product.ref === 'combo-letter' || product.ref === 'psd-letter-combo') &&
                    <div className="align-items-center d-flex mx-3">
                      <span className="mr-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M20.0001 8.02393L14.0001 2.76393C13.4501 2.27198 12.738 2 12.0001 2C11.2622 2 10.5501 2.27198 10.0001 2.76393L4.00009 8.02393C3.68246 8.30801 3.42899 8.65649 3.25657 9.04618C3.08414 9.43586 2.99671 9.85781 3.00009 10.2839V19.0239C3.00009 19.8196 3.31617 20.5826 3.87877 21.1453C4.44138 21.7079 5.20445 22.0239 6.00009 22.0239H18.0001C18.7957 22.0239 19.5588 21.7079 20.1214 21.1453C20.684 20.5826 21.0001 19.8196 21.0001 19.0239V10.2739C21.0021 9.84949 20.9139 9.42947 20.7416 9.04161C20.5692 8.65375 20.3165 8.30689 20.0001 8.02393ZM14.0001 20.0239H10.0001V15.0239C10.0001 14.7587 10.1055 14.5044 10.293 14.3168C10.4805 14.1293 10.7349 14.0239 11.0001 14.0239H13.0001C13.2653 14.0239 13.5197 14.1293 13.7072 14.3168C13.8947 14.5044 14.0001 14.7587 14.0001 15.0239V20.0239ZM19.0001 19.0239C19.0001 19.2891 18.8947 19.5435 18.7072 19.731C18.5197 19.9186 18.2653 20.0239 18.0001 20.0239H16.0001V15.0239C16.0001 14.2283 15.684 13.4652 15.1214 12.9026C14.5588 12.34 13.7957 12.0239 13.0001 12.0239H11.0001C10.2044 12.0239 9.44138 12.34 8.87877 12.9026C8.31616 13.4652 8.00009 14.2283 8.00009 15.0239V20.0239H6.00009C5.73488 20.0239 5.48052 19.9186 5.29299 19.731C5.10545 19.5435 5.00009 19.2891 5.00009 19.0239V10.2739C5.00027 10.1319 5.03069 9.99163 5.08931 9.86231C5.14794 9.73299 5.23343 9.61764 5.3401 9.52393L11.3401 4.27393C11.5226 4.11361 11.7572 4.0252 12.0001 4.0252C12.243 4.0252 12.4776 4.11361 12.6601 4.27393L18.6601 9.52393C18.7668 9.61764 18.8523 9.73299 18.9109 9.86231C18.9695 9.99163 18.9999 10.1319 19.0001 10.2739V19.0239Z"
                            fill="#7EC7D1"/>
                        </svg>
                      </span>
                      <span className="text-blured"><b>Housing</b></span>
                    </div>
                    }
                  </div>
                  <h4 className="mb-0">{product.data.title}</h4>
                </div>
                <div className="product-card-item d-flex justify-content-center p-3">
                  <h2 className="text-primary mb-0">{"$" + product.price}</h2>
                </div>
                <div className="product-card-item">
                  <ul className="pl-3 text-medium">
                    {
                      product.data.features.map((feature, index) => (
                        <li className="mb-2" key={index}>
                          {feature}
                        </li>
                      ))
                    }
                  </ul>
                  <div className="text-center">
                    <Button className="mt-2 mt-lg-4"
                            onClick={() => this.onAddToCart(product.id)}>
                      Get started
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.questions,
    productId: state.payment.productId
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      questionsActions: bindActionCreators(questionsActions, dispatch),
      paymentActions: bindActionCreators(paymentActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);